import { round2 } from "./calc";

const KEY = "brv_handoff";
const HAUL_RE = /^[A-Za-z0-9_-]{1,64}$/;

export const positive = (v) => {
  const s = (v || "").trim();
  return /^\d+(\.\d+)?$/.test(s) && parseFloat(s) > 0 ? s : null;
};

export const validHaulId = (v) => (typeof v === "string" && HAUL_RE.test(v) ? v : null);

export function readHandoff(params) {
  const miles = positive(params.get("miles"));
  const payout = positive(params.get("payout"));
  const haul = validHaulId(params.get("haul_id"));
  return { ...(miles && { loaded_miles: miles }), ...(payout && { offer: payout }), ...(haul && { haul_id: haul }) };
}

export const prefillFields = (h) => ({
  ...(positive(h.loaded_miles) && { loaded_miles: h.loaded_miles }),
  ...(positive(h.offer) && { offer: h.offer }),
});

export const saveHandoff = (h) => sessionStorage.setItem(KEY, JSON.stringify(h));

export const loadHandoff = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

export const clearHandoff = () => sessionStorage.removeItem(KEY);

const fill = (tpl, key, value) => tpl.split(`{${key}}`).join(encodeURIComponent(value));

export const buildBidUrl = (template, haulId, quote) => fill(fill(template, "haul_id", haulId), "quote", round2(quote).toFixed(2));

export const showSendQuote = (haulId, quote, template) =>
  Boolean(validHaulId(haulId) && template && quote !== null && Number.isFinite(quote) && quote > 0);
